module.exports = __webpack_public_path__ + "img/3.cb225e32.jpg";